import { InjectionToken } from '@tanbo/vue-di-plugin'
import { Router } from 'vue-router'

export const routerInjectToken = new InjectionToken<Router>('router-token')
